import { useContext } from 'react';
import { PredictContext } from '~/providers/PredictProvider';
import { PredictContextType } from '~/types/predict';

// Need to export the context from the provider for this hook
// This hook provides access to the discharge context
export const usePredictContext = (): PredictContextType => {
  const context = useContext(PredictContext);

  if (!context) {
    throw new Error('usePredictContext must be used within PredictProvider');
  }

  return context;
};
